import moment from "moment-timezone";
import getClasses from "utils/getClasses";
import styles from "../ScrollableCalendarViewHeader.module.scss";

const DayLabel = ({
  date,
  timezone,
  today,
  dayOfWeek,
  isWeeklyView,
  handleDayLabelClick,
}: {
  date: Date;
  timezone: string;
  today: Date;
  dayOfWeek: string;
  isWeeklyView: boolean;
  handleDayLabelClick: (date: Date) => void;
}) => {
  const dateMoment = moment(date).tz(timezone);
  const dayOfMonth = dateMoment.format("D");

  const isToday = dateMoment.isSame(today, "day");
  const isInThePast = dateMoment.isBefore(today, "day");

  return (
    <th key={dayOfWeek} className={styles["date"]}>
      <div className={styles["th-body"]}>
        <div className={isInThePast ? styles["day-of-week-label--past"] : ""}>
          {dayOfWeek}
        </div>
        <div
          className={getClasses(
            styles["day-of-month-label"],
            isToday && styles["day-of-month-label--today"],
            isInThePast && styles["day-of-month-label--past"],
            isWeeklyView && styles["day-of-month-label--week"],
          )}
          onClick={() => handleDayLabelClick(date)}
        >
          {dayOfMonth}
        </div>
      </div>
    </th>
  );
};

export default DayLabel;
